const initBanner = () => {
   const banner = document.querySelector(".banner--tgu"),
     form = document.querySelector(".form--tgu"),
     home = document.querySelector(".home");

   if (!banner || !form || !home) return;

   const trackScroll = () => {
     const scrolled = window.pageYOffset;
     if (scrolled < home.offsetTop + home.clientHeight) {
       banner.classList.remove('active');
     } else if (
       scrolled + document.documentElement.clientHeight >
       form.offsetTop
     ) {
       banner.classList.remove('active');
     } else if (scrolled < form.offsetTop) {
       banner.classList.add('active');
     }
   };
   window.addEventListener("scroll", trackScroll);
 };
 
 export default initBanner;
 